/* eslint-disable consistent-return */
/* eslint-disable no-invalid-this */
import { removeAuthData } from '&/services/auth.service';
import store from '@/store';
import usersService from '../../services/users.service';

/**
 * @override
 * @param {*} to destino
 * @param {*} from origen
 * @param {*} next retorno
 */
export default function(to, from, next) {
  if (
    to.name === 'login' ||
    to.name === 'login365' ||
    to.name === 'login-third-party' ||
    to.name === 'password-reset' ||
    to.name === 'new-password'
  ) {
    return next();
  }
  usersService
    .getMe()
    .then(res => {
      store.dispatch('meStore/setIssues', res.data.issues);
      return next();
    })
    .catch(() => {
      removeAuthData()
        .then(() => {
          store.dispatch('yuriMenuStore/reset');
          store.dispatch('formStore/deleteAllForms');
        })
        .then(() => {
          return next('login');
        });
    });
}
